import React from 'react'
import {KTIcon} from '@/_metronic/helpers'
import {Transaction} from '../../core/_models'
import {useListView} from '@/components/table/core/ListViewProvider'
import {useIntl} from 'react-intl'
import {ReactCountryFlag} from 'react-country-flag'
import States from '../../../../statement/list/components/States'

export const TrxOverview = () => {
  const intl = useIntl()
  const {itemForUpdate, setItemForUpdate, setAction} = useListView()

  const trx = itemForUpdate as Transaction

  if (trx === undefined || trx === null) {
    return <></>
  }
  const close = () => {
    setAction(undefined)
    setItemForUpdate(undefined)
  }

  return (
    <div>
      <div className='table-responsive'>
        {/* begin::Table */}
        <table className='table align-middle gs-0 gy-5'>
          <tbody>
            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                Operation ID
              </td>
              <td className='text-start'>
                <span className='badge badge-light-danger fw-semibold me-1'>
                  {trx._id}
                </span>
              </td>
            </tr>

            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                Gateway TRXID
              </td>
              <td className='text-start'>
                <span className='badge badge-light-info fw-semibold me-1'>
                  {trx.trxId}
                </span>
              </td>
            </tr>

            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                Date
              </td>
              <td className='text-start'>
                <span className='badge badge-light fw-semibold me-1'>
                  {intl.formatDate(trx.date, {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                  })}
                </span>
              </td>
            </tr>

            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                States
              </td>
              <td className='text-start'>
                <States states={trx.statuses} scope="TRX"/>
              </td>
            </tr>

            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                Payment Mode
              </td>
              <td className='text-start'>
                {trx.country && (
                  <ReactCountryFlag
                    countryCode={trx.country}
                    style={{ fontSize: '1.5em' }}
                    className="me-2"
                  />
                )}

                <span className={`badge badge-light-primary fw-bold me-1`}>
                  {intl.formatMessage({id: `P2C.PAYMODE_${trx?.type?.toUpperCase()}`})}
                </span>
                {trx.amount && intl.formatNumber(trx.amount, {
                  style: 'currency',
                  currency: trx.currency,
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
                <span> / </span>
                {intl.formatNumber(trx.payout || 0, {
                  style: 'currency',
                  currency: trx.payoutCurrency,
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}

              </td>
            </tr>

            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                Msisdn
              </td>
              <td className='text-start'>
                {trx.msisdn ? trx.msisdn.replace(/(\d{2})(?=\d)/g, '$1 ') : '-'}
                <span className={`badge badge-primary fw-bold ms-1`}>
                  {trx.carrier ? trx.carrier : ''}
                </span>

                {trx.alias && (
                  <div className="fst-italic text-muted">
                    Alias: {trx.alias}
                  </div>
                )}
              </td>
            </tr>

            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                Code
              </td>
              <td className='text-start'>
                {trx.code ?? '-'}
              </td>
            </tr>

            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                PSP
              </td>
              <td className='text-start'>
                {trx?.psp?.name ?? '-'}
                {trx?.psp?.trxId && (
                  <span className='badge badge-light-danger fw-semibold me-1'>
                    {trx.psp.trxId}
                  </span>
                )}
              </td>
            </tr>

            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                Credits
              </td>
              <td className='text-start'>
                {!trx.credit ? (
                  <>
                    {trx.statuses.at(-1)?.status === 'STATUS_SUCCEED' && (
                      <span className="text-danger d-flex">
                        <KTIcon iconName='information' className='fs-1 text-danger me-2' />
                        Missing credits
                      </span>
                    )}
                  </>
                ) : (
                  <>
                    {intl.formatNumber(trx.credit, {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0
                    })}
                  </>
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {trx?.instructions !== null && (
        <>
          <div
            className="d-flex align-items-center collapsed collapsible py-3 toggle mb-0"
            data-bs-toggle="collapse"
            data-bs-target="#instructions"
          >
            <div className="btn btn-sm btn-icon mw-20px btn-active-color-primary me-5">
              <KTIcon iconName='minus-square' className='toggle-on text-primary fs-1' />
              <KTIcon iconName='plus-square' className='toggle-off text-primary fs-1' />
            </div>
            <h4 className="text-gray-700 fw-bold cursor-pointer mb-0">
              Instructions
            </h4>
          </div>
          <div id="instructions" className="collapse fs-6 ms-1">
            <table className='table align-middle gs-0 gy-5'>
              <tbody>
                {trx.instructions?.phone && (
                  <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                    <td className='text-start text-gray-700 fw-bold'>
                      Phone number
                    </td>
                    <td className='text-start'>
                      {trx.instructions.phone}
                    </td>
                  </tr>
                )}

                {trx.instructions?.keyword && (
                  <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                    <td className='text-start text-gray-700 fw-bold'>
                      Keyword
                    </td>
                    <td className='text-start'>
                      {trx.instructions.keyword}
                    </td>
                  </tr>
                )}

                {trx.instructions?.shortcode && (
                  <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                    <td className='text-start text-gray-700 fw-bold'>
                      Shortcode
                    </td>
                    <td className='text-start'>
                      {trx.instructions.shortcode}
                    </td>
                </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}

      {(trx?.error && Object.keys(trx.error).length !== 0) && (
        <>
          <div className="d-flex align-items-center collapsed collapsible py-3 toggle mb-0" data-bs-toggle="collapse" data-bs-target="#error">
            <div className="btn btn-sm btn-icon mw-20px btn-active-color-primary me-5">
              <KTIcon iconName='minus-square' className='toggle-on text-danger fs-1' />
              <KTIcon iconName='plus-square' className='toggle-off text-danger fs-1' />
            </div>
            <h4 className="text-danger fw-bold cursor-pointer mb-0">
              Error
            </h4>
          </div>
          <div id="error" className="collapse fs-6 ms-1">
            <div className="mb-4 text-gray-600 fw-semibold fs-6">
              <pre>{JSON.stringify(trx.error, null, 2)}</pre>
            </div>
          </div>
        </>
      )}

      <div className="pt-5 text-end">
        <button
          type='reset'
          onClick={() => close() }
          className='btn btn-light me-3'
          data-kt-users-modal-action='cancel'
        >
          Close
        </button>
      </div>
    </div>
  )
}

